export enum Address {
    ESTONIAN = 'estonian',
    FOREIGN = 'foreign'
}
